import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { pickDetail } from '../lib/data'

const TIER_STYLE = {
  'Critical': { bg: '#FCEBEB', color: '#A32D2D', dot: '🔴' },
  'High':     { bg: '#FAEEDA', color: '#854F0B', dot: '🟡' },
  'Medium':   { bg: '#EAF3DE', color: '#3B6D11', dot: '🟢' },
  'Low':      { bg: '#F1EFE8', color: '#5F5E5A', dot: '⚪' },
}

export default function Audits() {
  const navigate = useNavigate()
  const [audits, setAudits] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => { fetchAudits() }, [])

  async function fetchAudits() {
    const { data } = await supabase
      .from('audits')
      .select('id, status, created_at, submitted_at, notes, sites(name, city, site_details(priority_tier, lpr_issue, gate_issue))')
      .order('created_at', { ascending: false })
    setAudits(data || [])
    setLoading(false)
  }

  const filtered = audits.filter(a =>
    a.sites?.name?.toLowerCase().includes(search.toLowerCase()) ||
    (a.sites?.city || '').toLowerCase().includes(search.toLowerCase())
  )

  if (loading) return <div className="spinner" />

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Audits</div>
          <div className="page-subtitle">{audits.length} total</div>
        </div>
        <button className="btn btn-primary btn-sm" onClick={() => navigate('/audits/new')}>
          + New
        </button>
      </div>

      <input
        className="form-input"
        placeholder="Search by site name or city..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ marginBottom: 16 }}
      />

      {filtered.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📋</div>
          <h3>No audits found</h3>
          <p>Start a new audit to get going.</p>
        </div>
      ) : (
        filtered.map(audit => {
          const det = pickDetail(audit.sites?.site_details)
          const tier = det?.priority_tier
          const ts = TIER_STYLE[tier]
          return (
            <div key={audit.id} className="site-item" onClick={() => navigate(`/audits/${audit.id}`)}>
              <div className={`site-dot ${audit.status === 'submitted' ? 'site-dot-complete' : 'site-dot-partial'}`} />
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <div className="site-name">{audit.sites?.name || 'Unknown site'}</div>
                  {tier && (
                    <span style={{
                      fontSize: 11, padding: '2px 7px', borderRadius: 10,
                      background: ts?.bg, color: ts?.color, fontWeight: 500,
                    }}>
                      {ts?.dot} {tier}
                    </span>
                  )}
                </div>
                <div className="site-meta">
                  {audit.sites?.city && `${audit.sites.city} · `}
                  {new Date(audit.created_at).toLocaleDateString()}
                  {det?.lpr_issue ? ' · ⚠️ LPR' : ''}
                  {det?.gate_issue ? ' · ⚠️ Gate' : ''}
                </div>
              </div>
              <span className={`badge ${audit.status === 'submitted' ? 'badge-pass' : 'badge-warn'}`}>
                {audit.status === 'submitted' ? 'Submitted' : 'In progress'}
              </span>
            </div>
          )
        })
      )}
    </div>
  )
}
